// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useState, useEffect } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import PartyAddMemberSearch from './PartyAddMemberSearch';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import PartyAddMemberTable from './PartyAddMemberTable';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import Spinner from '../../utils/Spinner';

const ModalContainer = styled.div`
    position: relative
    padding-top: 20px;
    margin-left: 30px;
`;

const SpinnerContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 5rem;
  bottom: 0;
  margin: auto;
`;

const StyledTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  span {
    text-decoration: underline;
  }
`;

const StyledNote = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 25px;
`;

const PartyAddMemberModal = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  party,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  loadUsers,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  users,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  setUsers,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  searchUsersSort,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onUsersSortChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  addGuest,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isGuestAddingLoaded,
}) => {
  const [emailValue, setEmailValue] = useState('');

  useEffect(
    () => () => {
      setUsers([]);
    },
    []
  );

  useEffect(() => {
    if (emailValue.length < 3) return;
    loadUsers(emailValue);
  }, [emailValue]);

  const onSortClick = name => {
    onUsersSortChange(name, emailValue);
  };

  const onAddGuestClick = user => {
    addGuest(party, user);
  };

  return (
    <ModalContainer>
      {isGuestAddingLoaded && (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      )}
      <StyledTitle>
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        Who do you want to add to <span>{party.partyName}</span> party?
      </StyledTitle>
      <StyledNote>Note: must be an existing BACH user</StyledNote>
      <PartyAddMemberSearch
        emailValue={emailValue}
        setEmailValue={setEmailValue}
      />
      <PartyAddMemberTable
        users={users}
        activeSort={searchUsersSort}
        onSortClick={onSortClick}
        onAddGuestClick={onAddGuestClick}
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/prop-types
        members={party.members}
      />
    </ModalContainer>
  );
};

export default React.memo(PartyAddMemberModal);
